import axios, { AxiosError } from "axios";
import { decryptData } from "./Decryption";

export const reqFunction = async (
  URL: string,
  Data: object,
  requestType: "get" | "post" = "post"
) => {
  const TOKEN = window.localStorage.getItem("token");
  const noAuthNeeded = ["admins/admin/login", "users/user/login"];

  try {
    if (TOKEN || noAuthNeeded.includes(URL)) {
      const headers: Record<string, string> = {};

      if (!noAuthNeeded.includes(URL) && TOKEN) {
        headers["token"] = JSON.parse(TOKEN);
      }

      const config = { headers };

      const response =
        requestType === "post"
          ? await axios.post(
              process.env.REACT_APP_SAYAL_API_ENDPOINT_MAIN + `/${URL}`,
              Data,
              config
            )
          : await axios.get(
              process.env.REACT_APP_SAYAL_API_ENDPOINT_MAIN + `/${URL}`,
              config
            );

      //decryption key
      const decryptionKey = "f675e6d9e84f419ba71b87a1fb57dfd5";

      // Check if the data field is encrypted and decrypt it
      let responseData = response.data;
      if (typeof responseData.data === "string") {
        responseData.data = decryptData(responseData.data, decryptionKey, URL);
      }

      return responseData;
    } else {
      return { code: 403, data: [] };
    }
  } catch (error) {
    // Default safe error payload
    const safeError = {
      ok: false,
      message: "سرویس موقتا غیرفعال است. لطفا صبر کنید.",
      trackingId: null as string | null,
      status: null as number | null,
    };

    if (axios.isAxiosError(error)) {
      const status = error.response?.status ?? null;
      const data: any = error.response?.data;

      // Try to extract trackingId from backend JSON or from header
      const headerTrackingId =
        (error.response?.headers?.["x-tracking-id"] as string | undefined) ??
        null;

      const bodyTrackingId = data?.trackingId ?? data?.tracking_id ?? null;

      const trackingId = bodyTrackingId || headerTrackingId;

      // If server responded with our safe JSON, return it as-is (but keep it safe)
      if (status && data && typeof data === "object") {
        // For AFTA: never display internal messages; only allow our known shape
        if ("ok" in data && "message" in data) {
          return {
            ...data,
            trackingId: trackingId ?? data.trackingId ?? null,
            status,
          };
        }
      }

      // No response or unexpected error shape => return generic safe error
      return {
        ...safeError,
        status,
        trackingId,
      };
    }

    // Non-axios error
    return safeError;
  }
};
